// ***********************************
// BatchEdit.vue
// ***********************************
<template>
  <div id="app">
    <div class="container">
      <div>
        <router-link :to="{ name: 'BatchHome'}">List</router-link> | 
        <router-link :to="{ name: 'BatchAdd'}">Add</router-link> |
        <router-link :to="{ name: 'Profile' }">Share</router-link> 
      </div>
      <br/>
      <b-alert :show="showAlert" :variant="alertStyle">{{alertText}}
        <div v-show="showAlert && alertStyle=='success'">
          <router-link :to="{ name: 'BatchHome' }">Click here to continue</router-link>
        </div>
      </b-alert>
      <b-card v-if="!showAlert" header="Edit your Batch">
        <b-list-group>






          <b-form @submit="onSubmit" @reset="onReset" v-if="show">


      
          <b-list-group-item>
            <div>
              <b>Update details about this batch.</b>
              <b-card bg-variant="light" class="text-left">

                  <b-form-group id="exampleInputGroup2" label="Customer Name:" label-for="customer">
                    <b-form-input
                      id="customer"
                      type="text"
                      v-model="form.customer"
                      required
                      placeholder="Enter customer name."
                      list="my-list-id">
                    </b-form-input>
                    <datalist id="my-list-id">
                      <option v-for="(item, index) in this.CustomerChoices" :key="index">{{ item.value }}</option>
                    </datalist>
                  </b-form-group>

                  <b-form-group id="exampleInputGroup3" label="Batch Name:" label-for="batchname">
                    <b-form-input
                      id="batchname"
                      type="text"
                      v-model="form.batchname"
                      required
                      placeholder="Enter batch name."
                    ></b-form-input>
                  </b-form-group>

                 <b-form-group id="exampleInputGroup4" label="Description:" label-for="descr">
                    <b-form-textarea
                      id="descr"
                      v-model="form.descr"
                      required
                      placeholder="Enter a description for this batch of databases."
                      :rows="3"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
            
              </b-card>
            </div>
          </b-list-group-item>

          <b-list-group-item>
            <div>
              <div v-b-tooltip.hover title="You can use this to do certain tricks like combining databases from different batches." >
                <b>ADVANCED: Manually edit the list of DBCSI collectionIDs that are part of the batch</b>
              </div>  
              <b-card bg-variant="light" class="text-left">
                  
              <div id="demo">
                

                
                 <b-form-group id="exampleInputGroup5" label="List of Databases (DBCSI collectionIDs) to be in the batch:" label-for="collectionIDs"
                   v-b-popover.hover.top="'You can provide a list of DBCSI collectionIDs (one per line) that will define your batch.  Providing your own list might make it easier for you to define your batch than using the browser UI.  You will still need to have permissions for each collectionID to be able to view it.'">
                    <b-form-textarea
                      id="collectionIDs"
                      v-model="form.collectionIDs"
                      required
                      placeholder="Enter a list of DBCSI collectionIDs."
                      :rows="3"
                      :max-rows="6"
                    ></b-form-textarea>
                  </b-form-group>
                
                
                
                <br/>
                List of Databases currently in the batch:
                
               <b-table
                  :per-page="perPage"
                  :current-page="currentInputPage"
                  striped
                  hover
                  responsive
                  bordered
                  :items="batchItems"
                  :fields="inputFields"
                  :sort-by.sync="inputSortBy"
                  class="table table-sm"
                >

                  <template #cell(database)="row">
                    <a v-b-tooltip.hover :title="`${row.item.description}`" :href="`/metrics/${row.item.collectionID}/ora_v1`" target="_blank">{{ row.item.database }}</a>
                  </template>
                  <!--<template #cell(collectionID)="data">-->
                  <!--  <a :href="`/metrics/${data.value}/ora_v1`" target="_blank">{{ data.value }}</a>-->
                  <!--</template>-->
                </b-table>
                <b-pagination
                  :total-rows="batchItems.length"
                  :per-page="perPage"
                  v-model="currentInputPage"
                  size="sm"
                  align="center"
                />
 
              </div>
              </b-card>
            </div>
          </b-list-group-item>





          <b-list-group-item>
            <div>
              <b>Save your new batch definition</b>
              <b-card bg-variant="light" class="text-left">
                <div class="text-center">
                  <b-alert variant="danger" :show="showSampleAlert">The "sample" user is not allowed to upload new databases.  Please sign-out and create your own user.</b-alert>

                  <b-button type="submit" :disabled="showSampleAlert" variant="primary">Save</b-button>
                  <!--<b-button type="reset" variant="danger">Reset</b-button>-->
                </div>
              </b-card>
            </div>
          </b-list-group-item>
          </b-form>      
        </b-list-group>
        
  
        
      </b-card>
    </div>
  </div>
</template>    


<script>
import { API, Storage } from "aws-amplify";
export default {
  name: "app",
  props: ["batch_id", "batchname", "descr", "customer", "user"],
  data() {
    return {
      selected: null,
      output_file: null,
      batchItems: [{ database: "Retrieving Data..." }],
      collection_list: [
        {
          collection_id: "0",
          descr: "Please wait while we load data..."
          // db_type: "Oracle",
          // collection_type: "ora_v1",
          // status: "processed",
          // descr: "another collection example",
          // collection_date: "2018-12-14 15:00:19",
          // customer: "Octank Gaming"
        }
      ],
      inputSortBy: "row",
      currentInputPage: 1,
     inputFields: [
        {row: {
          label: "row",
          sortable: true
        }},
        // {collectionID: {
        //   label: "Collection",
        //   sortable: true
        // }},
        {database: {
          label: "Database",
          sortable: true
        }},
        {description: {
          label: "Description",
          sortable: true
        }},
        {hostname: {
          label: "Host",
          sortable: true
        }},

        {collectionID: {
          label: "CollectionID",
          sortable: true
        }}
      ],
      
      perPage: 15,
      form: {
        customer: "",
        batchname: "",
        descr: "",
        collectionIDs: ""
      },
      show: true,
      showAlert: false,
      showFileAlert: false,
      showSampleAlert: false,
      isUploading: false,
      alertText: "",
      alertStyle: "default",
      alertFileText: "",
      CustomerChoices: [
          { value: 'Customer1', text: 'Customer1' },
      ]
    };
  },
  async created() {    
  
    this.form.descr = this.descr;
    this.form.batchname = this.batchname;
    this.form.customer = this.customer;

    if (this.user=="sample") {
      this.showSampleAlert = true;
    }    
    
    var tries = 2;
    while (tries > 0) {
      await API.get(
        "dbcsiAPI",
        `/dbcsi/batch/${this.batch_id}`
      )
        .then(response => {
					// console.log("get batch success "+response.success);
					if (response.success) {
          this.batchItems = response.data;
          
          //are any of these batchItems non X86?
          var myString = "";
          this.form.collectionIDs="";
          for (var i of this.batchItems) {
            myString+= i.collectionID +'\n';
            
          }
					tries = 0;
					this.form.collectionIDs=myString;
					// console.log("get batch set batchItems:"+this.batchItems.length);
					}
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Batch-batchItems Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });
      tries -= 1;
		}

    var tries = 10;
    while (tries > 0) {
      await API.get("dbcsiAPI", `/dbcsi/customers`)
        .then(response => {
          // console.log("Add: I am here3");
          //use .shift() to remove the first row
          var filteredItems = response.data.filter(item => item.value !== 'xxALL');
          this.CustomerChoices = filteredItems;
          tries = 0;
          // console.log(this.genItems);
        })
        .catch(error => {
          console.log("Add Error:", error);
          console.log("Will retry.  Attempts Left:", (tries-1));
        });

      tries -= 1;
    }

    // console.log("I am here4");
  },


  
  methods: {

    async onSubmit(evt) {
      evt.preventDefault();
      let collection_type = "ora_v1";
      
      this.alertStyle="primary"
      this.alertText = "Saving batch definition to database... Please wait... Do not leave this page yet.";
      this.showAlert = true;
      this.isUploading = true;
      
      var tries = 3;
      var success = true;
      if (success) {
        // console.log("BatchEdit: I am here4");
        
        // get an array of just the collection_ids that are checked.
        
        
        const id_array = this.form.collectionIDs.replace(/,/g, '').split(/\r?\n/).filter(item => item.trim() !== '');
        var selected_ids = [];
        for (var i of id_array) {
            selected_ids.push({collection_id: i});
        }  
        // console.log(selected_ids);
        
        //do a put to /collections
        const putParams = {
          body: {
            db_type: "Oracle",
            customer: this.form.customer,
            batchname: this.form.batchname,
            descr: this.form.descr,
            collection_type: collection_type,
            collection_ids: selected_ids,
            batch_id: this.batch_id
          }
        };

        var new_id = null;
        var api_success = false;
        await API.put("dbcsiAPI", `/dbcsi/batch`, putParams)
          .then(response => {
            new_id = response.data.batch_id;
            api_success = true;
            // console.log("BatchEdit API.put: new batch_id=", new_id);
            this.alertText = "Batch defined successfully.";
            this.alertStyle="success";
            this.isUploading = false;

          })
          .catch(error => {
            console.log("BatchEdit API.put Error:", error);
            // alert("API.put error");
              this.alertText = "Database put error.";
              this.alertStyle="danger";
              this.isUploading = false;
          });

      }

      //   alert(JSON.stringify(this.form));
    },
    onReset(evt) {
      evt.preventDefault();
      /* Reset our form values */
      this.form.customer = "";
      this.form.descr = "";
      this.output_file = null;
      this.$refs.fileinput.reset();
      /* Trick to reset/clear native browser form validation state */
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    }

  }
};
</script>

<style>
</style>
